import { extendTheme } from "@chakra-ui/react";

const colors = {
  white: '#FFFFFF',
  error: '#FF3C3C',
  primary: {
    50: '#FFE8E9',
    100: '#FFC6C8',
    200: '#FFA0A4',
    300: '#FF7980',
    400: '#FF5D64',
    500: '#FF4049',
    600: '#FF3A42',
    700: '#FF3239',
    800: '#FF2A31',
    900: '#FF1C21',
  },
  grey: {
    50: '#F3F2F1',
    100: '#E1DEDD',
    200: '#CDC8C6',
    300: '#B8B1AF',
    400: '#A9A19E',
    500: '#9A908D',
    600: '#928885',
    700: '#887D7A',
    800: '#7E7370',
    900: '#6C615D',
  },
  textColors: {
    primary: 'rgba(0, 0, 0, 0.84)',
    secondary: 'rgba(0, 0, 0, 0.60)',
    disabled: 'rgba(0, 0, 0, 0.24)',
    placeholder: 'rgba(0, 0, 0, 0.24)',
    border: 'rgba(0, 0, 0, 0.12)',
  },
  mood: {
    happy: '#8AB7FE',
    calm: '#DBA5D5',
    unhappy: '#FD8788',
  },
};

const theme = extendTheme({
  colors,
  styles: {
    global: {
      html: {
        bg: "#F4F5F7",
      },
      body: {
        bg: "radial-gradient(circle at 18% 4%, rgba(217, 238, 251, 0.92), transparent 34rem), radial-gradient(circle at 88% 12%, rgba(255, 232, 235, 0.92), transparent 38rem), #F4F5F7",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 700,
        borderRadius: 'lg',
      },
      defaultProps: {
        colorScheme: 'primary',
      },
    },
  },
});

export default theme;
